/*
 * To add to the config, add an object:
 * {
 *  type: 'link' | 'meta',
 *  sizes: 'widthxheight',
 *  rel: 'rel value'
 *  filename: <Name of your file'
 * }
 */

const configHelmet = {
  meta: [
    { charset: "utf-8" },
    // Setting IE=edge tells Internet Explorer to use the latest
    // engine to render the page and execute Javascript
    { "http-equiv": "X-UA-Compatible", content: "IE=edge" },
    //  Meta descriptions are commonly used on search engine
    // result pages to display preview snippets for a given page.
    { name: "description", content: "Shipping Tracking Page" },
    { name: "keywords", content: "international, ecommerce, package, webinterpret, tracking, parcel, shipping" },
    { name: "application-name", content: "Webinterpret Tracking Page" },
    // Mobile Safari introduced this tag to let web developers control the viewport's size and scale
    // The width property controls the size of the viewport, the initial-scale property controls
    // the zoom level when the page is first loaded
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    // Add to homescreen for Chrome on Android
    { name: "mobile-web-app-capable", content: "yes" },
    // Add to homescreen for Safari on IOS
    { name: "apple-mobile-web-app-capable", content: "yes" },
    { name: "apple-mobile-web-app-status-bar-style", content: "black" },
    { name: "apple-mobile-web-app-title", content: "Webinterpret Tracking Page" },
    // Tile icon for Win8 (144x144 + tile color)
    // Add to homescreen for Windows App
    { name: "msapplication-config", content: "/assets/browserconfig.xml" },
    { name: "theme-color", content: "#ffffff" },
  ],
  link: [
    // Add to homescreen for Chrome on Android
    { rel: "icon", type: "image/png", href: "/assets/favicon-16x16.png", sizes: "16x16" },
    { rel: "icon", type: "image/png", href: "/assets/favicon-32x32.png", sizes: "32x32" },
    // Add to homescreen for Safari
    { rel: "apple-touch-icon", href: "/assets/apple-touch-icon.png", sizes: "180x180" },
    { rel: "mask-icon", href: "/assets/safari-pinned-tab.svg", color: "#1976d2" },

    // Others
    { rel: "manifest", href: "/assets/site.webmanifest" },
  ],
}

export default configHelmet



// WEBPACK FOOTER //
// ./src/views/helmconfig.js